import { createEntityAdapter } from '@reduxjs/toolkit';
import { stringPropertyComparator } from '@utils/common.utils';

import { Contact, Message } from '@/types/chat/chat.types';

export const contactsAdapter = createEntityAdapter<Contact, string>({
  selectId: (contact) => contact.code,
  sortComparer: stringPropertyComparator('name'),
});

export const messagesAdapter = createEntityAdapter<Message, number>({
  selectId: (message) => message.id,
  sortComparer: stringPropertyComparator('time'),
});
